/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

// Port of vpx-js lib/render/threejs/three-playfield-mesh-generator.ts.
// Changes: ExtrudeBufferGeometry is now ExtrudeGeometry; the input is a TableInfoSpec;
// the slab hangs below the playfield plane (the top face is at the table height); no UV
// generator (the playfield art is a separate decoration plane).

import type { BufferGeometry } from "three";
import type { TableInfoSpec } from "../../shared/contracts.ts";
import { extrudeOutline } from "./shared.ts";

/** Thickness of the playfield slab. The upstream value is 50. */
export const PLAYFIELD_THICKNESS = 50;

/** Build the playfield slab. The top face lies at the table height. */
export function generatePlayfieldGeometry(info: TableInfoSpec): BufferGeometry {
  const geometry = extrudeOutline(
    [
      { x: info.left, y: info.top },
      { x: info.right, y: info.top },
      { x: info.right, y: info.bottom },
      { x: info.left, y: info.bottom },
    ],
    PLAYFIELD_THICKNESS,
  );
  geometry.translate(0, (info.tableHeight ?? 0) - PLAYFIELD_THICKNESS, 0);
  geometry.name = "playfield";
  return geometry;
}
